module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAAAGCAYAAACl4YCPAAAAAXNSR0IArs4c6QAAAHpJREFUWEft08EJgDAMQNFmD92sFyexLqIXR3OPSAqFoj2mp/wMEMgnT6687Nv9HImhAAWmFDBjcuZVJWkB25TGLA1ewJBpklKhWQuwBf8Izncv0JBVXw0a2Nw7szBwgR7ZDxrYAn8Gp7sV+CIbQgObW28WBSwwQmYZXsrlMwvWO899AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sideButtonBar/down.png
// module id = uZPe
// module chunks = 1